import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, ShoppingBag, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const BEMCASH_ICON = "https://customer-assets.emergentagent.com/job_morarbem-saas/artifacts/e1f016yy_Iconebemcashsemfundo.png";

/**
 * Bottom Tab Bar — visível apenas em mobile (<lg).
 * 5 atalhos: Home / Descobrir / Carteira (B$) / Compras / Perfil.
 * Esconde nas páginas full-screen (Discover do mapa) para não cobrir conteúdo crítico.
 */
export default function BottomTabBar() {
  const { user } = useAuth();
  const loc = useLocation();

  // Esconde nas telas em fullscreen — manter na Discover (mapa e lista)
  const HIDE_ON = ["/login", "/register", "/verify-email"];
  const isGuide = loc.pathname.startsWith("/guia/");
  if (HIDE_ON.some((p) => loc.pathname.startsWith(p)) || isGuide) return null;

  const profilePath = user?.role === "ADMIN" ? "/admin" : user?.role === "MERCHANT" ? "/merchant" : user ? "/profile" : "/login";
  const ordersPath = user ? "/orders" : "/login?redirect=/orders";
  const walletPath = user ? "/wallet" : "/login?redirect=/wallet";

  const baseLink = "flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 transition-colors text-stone-500 active:scale-95";
  const activeCls = ({ isActive }) => `${baseLink} ${isActive ? "text-blue-900" : ""}`;

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-[450] bg-white/95 backdrop-blur border-t border-stone-200 shadow-[0_-2px_12px_rgba(0,0,0,0.05)] safe-bottom"
      data-testid="bottom-tab-bar"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex items-stretch">
        <NavLink to="/" end className={activeCls} data-testid="tab-home">
          {({ isActive }) => (<>
            <Home size={20} strokeWidth={isActive ? 2.4 : 1.8}/>
            <span className={`text-[10px] ${isActive ? "font-bold" : "font-medium"}`}>Início</span>
          </>)}
        </NavLink>

        <NavLink to="/discover/all" className={activeCls} data-testid="tab-discover">
          {({ isActive }) => (<>
            <Search size={20} strokeWidth={isActive ? 2.4 : 1.8}/>
            <span className={`text-[10px] ${isActive ? "font-bold" : "font-medium"}`}>Descobrir</span>
          </>)}
        </NavLink>

        <NavLink to={walletPath} className={activeCls} data-testid="tab-wallet">
          {({ isActive }) => (<>
            <div className={`relative -mt-3.5 w-12 h-12 rounded-full shadow-md flex items-center justify-center ${isActive ? "bg-amber-400 ring-2 ring-amber-200" : "bg-amber-300"}`}>
              <img src={BEMCASH_ICON} alt="BemCash" className="w-9 h-9 object-contain"/>
            </div>
            <span className={`text-[10px] mt-0.5 ${isActive ? "font-bold text-amber-700" : "font-medium"}`}>BemCash</span>
          </>)}
        </NavLink>

        <NavLink to={ordersPath} className={activeCls} data-testid="tab-orders">
          {({ isActive }) => (<>
            <ShoppingBag size={20} strokeWidth={isActive ? 2.4 : 1.8}/>
            <span className={`text-[10px] ${isActive ? "font-bold" : "font-medium"}`}>Compras</span>
          </>)}
        </NavLink>

        <NavLink to={profilePath} className={activeCls} data-testid="tab-profile">
          {({ isActive }) => (<>
            <User size={20} strokeWidth={isActive ? 2.4 : 1.8}/>
            <span className={`text-[10px] ${isActive ? "font-bold" : "font-medium"}`}>Perfil</span>
          </>)}
        </NavLink>
      </div>
    </nav>
  );
}
